<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-html="subsection.title"></h5>
      <div v-html="editedText"/>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
       :value="subsection.title"
       placeholder="Введите название"
       @input="$_subsectionMixin_onTitleChange" />
      <h4 class="mt-3">Текст</h4>
      <wysiwyg-text-editor dataType="subSectionText" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'
import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

export default {
  name: 'TextInfoSubSection',
  components: {
    WysiwygTextEditor
  },
  mixins: [ContentMixin, SubsectionMixin],
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editedText: ''
    }
  },
  mounted() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  computed: {
    ...mapGetters({
      subsection: 'education/getSubsection'
    })
  }
}
</script>

<style scoped>

</style>
